import axios from 'axios'

const baseUri = 'https://api.asistentemovistar.com.mx/api/';

var api = {
  baseUri: baseUri,
  post: function (endpoint, data) {
    return axios.post(baseUri + endpoint, data, {
      headers: { 'Content-Type': 'application/json' }
    });
  },
  get: function (endpoint) {
    return axios.get(baseUri + endpoint);
  }
};

export default api;
